import RefreshIcon from "@mui/icons-material/Refresh";
import ClearIcon from "@mui/icons-material/Clear";
import { MenuAction } from "../components/shared/step-content-box";

interface CreateMenuActionsParams {
  onRefresh: () => void;
  onClearSelection: () => void;
}

const createClientStepMenuActions = ({
  onRefresh,
  onClearSelection,
}: CreateMenuActionsParams): MenuAction[] => [
  {
    label: "Refresh Clients",
    icon: <RefreshIcon fontSize="small" />,
    onClick: onRefresh,
  },
  {
    label: "Clear Selection",
    icon: <ClearIcon fontSize="small" />,
    onClick: onClearSelection,
  },
];

export default createClientStepMenuActions;
